module.exports = __webpack_public_path__ + "university-ubc.png?a60dbab9fe8833d7e66c80fd84b70e10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/university-ubc.png
// module id = 152
// module chunks = 0